import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { adminChangePasswordRoute, gerAdminApplicantsMetricsRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList, assignedApplicant } from '../constants';

type useResetPasswordProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useResetPassword = ({
    setAlertText = () => { },
}: useResetPasswordProps) => {
    const client = useQueryClient();
    const { mutate: resetPassword, isLoading: isResetPasswordLoading } =
        useMutation({
            mutationFn: (variables: {
                user_id: number | string;
            }) =>
                axiosInstance
                    .post(adminChangePasswordRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries(adminEmployersList);
                client.invalidateQueries(adminEnterprisesList);
                setAlertText('');
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        resetPassword,
        isResetPasswordLoading,
    };
};
